const KEY = "hbai-conversations-v2";
const IMPORTED_KEY = "hbai-imported-for-user";

/**
 * Conversation shape:
 * {
 *   id: string,
 *   title: string,               // derived from first user message
 *   messages: { role: "user"|"assistant", content: string, ts: string }[],
 *   createdAt: string,           // ISO
 *   updatedAt: string,           // ISO
 * }
 */

export function loadConversations() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveConversations(list) {
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100)));
}

export function upsertConversation(conv) {
  const list = loadConversations();
  const idx = list.findIndex((c) => c.id === conv.id);
  if (idx >= 0) {
    list[idx] = conv;
  } else {
    list.unshift(conv);
  }
  // Keep the most recently updated at the top.
  list.sort((a, b) => (b.updatedAt || "").localeCompare(a.updatedAt || ""));
  saveConversations(list);
  return list;
}

export function deleteConversation(id) {
  const list = loadConversations().filter((c) => c.id !== id);
  saveConversations(list);
  return list;
}

export function clearConversations() {
  localStorage.removeItem(KEY);
  return [];
}

export function makeTitle(firstUserMessage) {
  const text = (firstUserMessage || "").trim().replace(/\s+/g, " ");
  if (!text) return "New chat";
  return text.length > 64 ? text.slice(0, 64) + "…" : text;
}

export function newConversationId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

// --- Local-vs-server bridge helpers ---
//
// Anonymous visitors store conversations only in localStorage. When they
// register, we offer a one-time prompt to import that history into their
// account. These helpers track whether a given user has already been
// offered the import, so we don't nag them on every login.

export function wasImportedFor(userId) {
  if (!userId) return true;
  try {
    const raw = localStorage.getItem(IMPORTED_KEY);
    if (!raw) return false;
    const map = JSON.parse(raw);
    return !!map[userId];
  } catch {
    return false;
  }
}

export function markImportedFor(userId) {
  if (!userId) return;
  try {
    const raw = localStorage.getItem(IMPORTED_KEY);
    const map = raw ? JSON.parse(raw) : {};
    map[userId] = true;
    localStorage.setItem(IMPORTED_KEY, JSON.stringify(map));
  } catch {
    /* ignore */
  }
}

export function hasLocalConversations() {
  return loadConversations().length > 0;
}
